import { useEffect } from "react";
import { clientNeoBanks } from "@neonumy/api-clients";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_BANK,
  CREATE_COMPANY_BANK_ACCOUNT,
  GET_BANK,
  GET_COMPANY_BANK_ACCOUNT,
  UPDATE_BANK,
  UPDATE_COMPANY_BANK_ACCOUNT,
} from "queries/centralApi/banks";

export default function useBankApi(id?: ID) {
  const [createUpdateCompanyBankAccount] = useMutation<
    CreateCompanyBankAccountResponse | UpdateCompanyBankAccountResponse,
    CreateCompanyBankAccountVars | UpdateCompanyBankAccountVars
  >(id ? UPDATE_COMPANY_BANK_ACCOUNT : CREATE_COMPANY_BANK_ACCOUNT, {
    client: clientNeoBanks,
    fetchPolicy: "no-cache",
  });
  const [createUpdateBank] = useMutation<
    CreateBankResponse | UpdateBankResponse,
    CreateBankVars | UpdateBankVars
  >(id ? UPDATE_BANK : CREATE_BANK, {
    client: clientNeoBanks,
    fetchPolicy: "no-cache",
  });

  const [
    getCompanyBankAccount,
    {
      refetch: refetchCompanyBankAccount,
      loading: companyBankAccountLoading,
      data: getCompanyBankAccountData,
      error: getCompanyBankAccountError,
    },
  ] = useLazyQuery<getCompanyAccountBankResponse, GetVarTypeID>(GET_COMPANY_BANK_ACCOUNT, {
    client: clientNeoBanks,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (getCompanyBankAccountError) onErrorGraphql(getCompanyBankAccountError);
  }, [getCompanyBankAccountError]);

  const bankAccountData = getCompanyBankAccountData?.getCompanyBankAccount;

  const [
    getBank,
    {
      refetch: refetchGetCompanyBank,
      loading: getCompanyBankLoading,
      data: getBankData,
      error: getBankError,
    },
  ] = useLazyQuery<getBankResponse, GetVarTypeID>(GET_BANK, {
    client: clientNeoBanks,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (getBankError) onErrorGraphql(getBankError);
  }, [getBankError]);

  const bankData = getBankData?.getBank;

  return {
    createUpdateCompanyBankAccount,
    companyBankAccountLoading,
    refetchCompanyBankAccount,
    createUpdateBank,
    getCompanyBankAccount,
    refetchGetCompanyBank,
    getCompanyBankLoading,
    bankData,
    getBank,
    bankAccountData,
  };
}
